import gql from 'graphql-tag';

export const GET_TWITTER_AUTH_URL = gql`
  query twitterAuthUrl($shopifyToken: String!) {
    twitterAuthUrl(shopifyToken: $shopifyToken) {
      url
    }
  }
`;

export const GET_JOBS = gql`
  query jobs($shopifyToken: String!, $templates: Boolean!, $status: String, $archived: Boolean) {
    jobs(shopifyToken: $shopifyToken, templates: $templates, status: $status, archived: $archived) {
      jobs {
        status
        title
        archived
        location
        category
        updatedAt
        createdAt
        statusUpdatedAt
        id
        employmentType
        managerEmail
        description
        isRemote
        maxCompensationRange
        minCompensationRange
        compensationEnabled
        compensationType
        currency
        totalCandidates
        department {
          id
          headingText
        }
      }
      allAccess
    }
  }
`;

export const GET_JOBS_VISITS = gql`
  query jobs($shopifyToken: String!, $templates: Boolean!) {
    jobs(shopifyToken: $shopifyToken, templates: $templates) {
      jobs {
        title
        id
        visits {
          id
          deviceType
          startedAt
          landingPage
        }
      }
    }
  }
`;

export const GET_EMAIL_TEMPLATE = gql`
  query emailTemplate($shopifyToken: String!, $emailTemplateId: String!) {
    emailTemplate(shopifyToken: $shopifyToken, emailTemplateId: $emailTemplateId) {
      title
      body
      id
      group
      variables
      subject
      updatedAt
      createdAt
      allAccess
      sender
      status
      senderEmail
    }
  }
`;

export const GET_EMAIL_TEMPLATES = gql`
  query emailTemplates($shopifyToken: String!) {
    emailTemplates(shopifyToken: $shopifyToken) {
      title
      body
      id
      variables
      subject
      status
      updatedAt
      createdAt
      group
    }
  }
`;

export const GET_CAREER_PORTAL = gql`
  query careerPortal($shopifyToken: String!) {
    careerPortal(shopifyToken: $shopifyToken) {
      id
      testimonials {
        id
        quote
        name
        testimonialPhoto
        role
      }
      headingText
      subheadingText
      sectionHero
      urlAndHandle
      metaDescription
      pageTitle
      allAccess
      deiStatment
      deiStatmentBody
      employeeTestimonial
      employeeTestimonialTitle
      jobListHeadingText
      jobListDepartmentFilterEnabled
      jobListCategoryFilterEnabled
      jobListLocationFilterEnabled
      jobListKeywordFilterEnabled
      jobListSortEnabled
      introductionBody
      introductionHeading
      introductionParagraph
      postApplyHeading
      postApplyBody
      postApplyButton
      postApplyButtonEnabled
      instagramUrl
      instagramButtonEnabled
      facebookUrl
      facebookButtonEnabled
      twitterUrl
      twitterButtonEnabled
      linkedinUrl
      linkedinButtonEnabled
      buttonText
      openRolesButton
      heroBackgroundImageReadPath
      styleControls
      departmentTitle
      departments {
        id
        headingText
        subheadingText
        isHighlight
      }
      departmentsSection
      benefitsHeading
      benefitsSubheading
      talentCommunitySection
      talentCommunityHeading
      talentCommunityBody
      talentCommunityButton
      talentCommunityForm
      benefits {
        id
        headingText
        iconKey
      }
      benefitsSection
      pageTimestamps
    }
  }
`;

export const GET_CANDIDATES = gql`
  query candidates($shopifyToken: String!, $status: String) {
    candidates(shopifyToken: $shopifyToken, status: $status) {
      id
      name
      lastName
      jobTitle
      phone
      createdAt
      updatedAt
      email
      resume
      status
      dispositionCode {
        id
        name
      }
      candidateScore {
        overallRating
      }
      candidateQuestionnaire {
        id
        score
        token
        answeredAt
        videos
      }
      tags {
        name
      }
      job {
        id
        category
        location
        isRemote
        department {
          id
        }
      }
    }
  }
`;

export const GET_SUBSCRIBERS = gql`
  query subscribers($shopifyToken: String!) {
    subscribers(shopifyToken: $shopifyToken) {
      id
      name
      lastName
      status
      interests
      phone
      resume
      createdAt
      updatedAt
      email
      visitorData
    }
  }
`;

export const GET_QUESTIONNAIRES = gql`
  query questionnaires($shopifyToken: String!) {
    questionnaires(shopifyToken: $shopifyToken) {
      id
      name
      status
      totalJobs
      fields
      jobs {
        id
        title
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_QUESTIONNAIRE = gql`
  query questionnaire($shopifyToken: String!, $questionnaireId: String!) {
    questionnaire(shopifyToken: $shopifyToken, questionnaireId: $questionnaireId) {
      id
      name
      status
      fields
      totalJobs
      createdAt
      updatedAt
    }
  }
`;

export const GET_CANDIDATES_CHART = gql`
  query candidates($shopifyToken: String!) {
    candidates(shopifyToken: $shopifyToken) {
      id
      jobTitle
      createdAt
      subscribe
      visitorData
      source
      status
      tags {
        name
      }
      dispositionCode {
        name
      }
      job {
        id
        visits {
          id
        }
      }
    }
  }
`;

export const GET_VISITS_DATA = gql`
  query shop($shopifyToken: String!) {
    shop(shopifyToken: $shopifyToken) {
      id
      visits {
        id
        events {
          id
          name
        }
        landingPage
        startedAt
        deviceType
      }
      subscribers {
        id
        email
        createdAt
      }
    }
  }
`;

export const GET_JOB_LOCATIONS = gql`
  query jobLocations($shopifyToken: String!) {
    jobLocations(shopifyToken: $shopifyToken) {
      name
      address1
      address2
      city
      zipCode
      state
      id
      country
    }
  }
`;

export const GET_HIRING_TEAM = gql`
  query hiringTeam($shopifyToken: String!) {
    hiringTeam(shopifyToken: $shopifyToken) {
      firstName
      lastName
      email
      id
    }
  }
`;

export const GET_TAGS = gql`
  query tags($shopifyToken: String!) {
    tags(shopifyToken: $shopifyToken) {
      name
    }
  }
`;

export const GET_CANDIDATE = gql`
  query candidate($shopifyToken: String!, $candidateId: String!) {
    candidate(shopifyToken: $shopifyToken, candidateId: $candidateId) {
      id
      name
      lastName
      jobTitle
      phone
      logs
      references
      comments {
        id
        user
        createdAt
        content
        attachment
      }
      address {
        address
        city
        id
        state
        unit
        zipcode
      }
      createdAt
      email
      resume
      status
      coverLetter
      socialLinks
      workExperiences {
        companyName
        endDate
        id
        jobTitle
        startDate
        current
      }
      customQuestions
      next
      previous
      tags {
        name
      }
      job {
        status
        title
        location
        category
        updatedAt
        id
        teamMembers {
          id
          firstName
          lastName
          email
        }
        questionnaires {
          id
        }
        department {
          id
          headingText
        }
        employmentType
        managerEmail
        description
        state
        city
        country
        postalCode
        isRemote
        status
        streetAddress
      }
      dispositionCode {
        id
        name
      }
      candidateScore {
        thoughts
        overallRating
      }
      candidateQuestionnaire {
        id
        score
        answers
        token
        answeredAt
        createdAt
        videos
      }
      visitorData
      source
    }
  }
`;

export const GET_JOB = gql`
  query job($shopifyToken: String!, $jobId: String!) {
    job(shopifyToken: $shopifyToken, jobId: $jobId) {
      status
      title
      location
      locationName
      category
      updatedAt
      archived
      id
      employmentType
      managerEmail
      description
      state
      city
      country
      postalCode
      isRemote
      totalCandidates
      department {
        id
        headingText
      }
      candidates {
        id
        name
        lastName
        jobTitle
        phone
        createdAt
        updatedAt
        email
        resume
        status
        coverLetter
        customQuestions
        tags {
          name
        }
        dispositionCode {
          id
          name
        }
        candidateScore {
          thoughts
          overallRating
        }
        candidateQuestionnaire {
          id
          score
          token
          answeredAt
        }
      }
      status
      statusUpdatedAt
      streetAddress
      currency
      next
      previous
      compensationEnabled
      compensationType
      minCompensationRange
      maxCompensationRange
      plusComission
      applicationFormFields
      customQuestions
      teamMembers {
        id
        firstName
        lastName
        email
      }
      questionnaires {
        id
        name
        updatedAt
        createdAt
        status
      }
      visits {
        id
        deviceType
        events {
          name
        }
      }
      jobSettings {
        id
        sendDisqualificationEmails
      }
      jobTranslations {
        id
        locale
        title
        description
        isActive
        createdAt
        updatedAt
        localeName
      }
      availableTranslations
    }
  }
`;

export const GET_SETTINGS_INFO = gql`
  query shop($shopifyToken: String!) {
    shop(shopifyToken: $shopifyToken) {
      shopifyDomain
      linkedinToken
      twitterToken
      airtableTokenExisting
      id
      sitemapLink
      sitemapSubmitted
      profile {
        id
        companyName
        contactEmail
        phoneNumber
        industry
        employeeSize
        branding
        weeklyApplicantSummary
        shopLogo
        recaptchaEnabled
        careerPageLink
      }
      locations {
        name
        id
        zipCode
        city
        state
        country
        address1
        address2
      }
      teamMembers {
        id
        firstName
        lastName
        email
      }
      dispositionCodes {
        id
        name
      }
      currentSubscription {
        id
        trialDays
        status
        appSubscriptionId
        currentPeriodEnd
        subscriptionType
        subscriptionPlan
        name
      }
      customWebhooks {
        eventName
        format
        id
        url
      }
      googleIndexIntegration {
        email
        token
        isActive
      }
      careerPortal {
        id
        departments {
          id
          headingText
          subheadingText
          isHighlight
        }
      }
    }
  }
`;

export const GET_CURRENT_SUBSCRIPTION = gql`
  query shop($shopifyToken: String!) {
    shop(shopifyToken: $shopifyToken) {
      linkedinToken
      twitterToken
      id
      shopifyDomain
      currentSubscription {
        id
        status
        subscriptionType
        subscriptionPlan
      }
      hasJobs
      allAccess
      openJobs
      dispositionCodes {
        id
        name
      }
      teamMembers {
        id
        firstName
        lastName
        email
      }
      createdAt
      careerPortalSet
      profile {
        id
        companyName
        onboardingControls
      }
      careerPortal {
        id
        departments {
          id
          headingText
          subheadingText
          isHighlight
        }
      }
    }
  }
`;
